export default __webpack_public_path__ + "static/media/iconoCrear2.39cdc5fb.svg";